export default {"src":"/polygon/_next/static/media/funds.586c5576.svg","height":25,"width":24};